<template>
    <router-link :to="{name:'Contact'}" class="">
        <!-- class="btn btn-warning btn-sm" -->
        <!-- Can’t find what you’re looking for? -->
        <!-- <img src="../../../assets/images/need_help_button.png" class="img-fluid" alt=""> -->
        <!-- <br><br> -->
        <!-- style="min-width:24em;" -->
        <div class="find d-flex align-items-center">
            <img src="../../../assets/images/navavatar.png" class="" alt="">
            <div class="text-left">
                Need help finding what you're looking for? <small class="text-uppercase">Click here</small>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: 'cannot-find-button',
}
</script>

<style lang="sass" scoped>
$blue: #17a2b8;
$yellow: #EFC200;
a:hover
    text-decoration: none
.find
    // width: 100%
    background-color: $blue
    color: white
    font-weight: bold
    border-bottom: 0.14em solid darken($blue, 6%)
    border-radius: 0.2em
    line-height: 1.2em
    // font-size: 1.2em
    &:hover
        border-bottom: 0.14em solid $blue
    img
        position: absolute
        top: -0.5em
        left: 24px
        width: 4.4em
    div
        // width: 80%
        margin-left: 5.6em
        padding: .5em 0 .3em 0
    small
        color: $yellow
        text-decoration: underline
        font-weight: bold
@media (min-width: 1200px)
  .find
    font-size: 1.2em
@media (max-width: 800px)
  .find
    font-size: 1em
    padding-left: .5em
.btn-yellow
    color: #000
    background-color: #efc200
</style>





// WEBPACK FOOTER //
// src/components/modules/cannot-find-button/cannot-find-button.vue